import * as yup from "yup";


export interface MeetingForm {
    title: string;
    description: string;
    mode: "Online" | "Offline";
    // meetingLink?: string;
    roomNo?: string;
    startTime: string;
    endTime: string;
    date: string;
    participantType: "Employee" | "Team" | "Mixed";
    selectedParticipants: number[];
    // companyIds: number[];
    // branchIds: number[];
    platform?: "GMEET"
}

export const EmptyMeetingForm: MeetingForm = {
    title: "",
    description: "",
    mode: "Online",
    // meetingLink: "",
    roomNo: "",
    startTime: "",
    endTime: "",
    date: new Date().toLocaleDateString("en-CA"),
    participantType: "Employee",
    selectedParticipants: [],
    // companyIds: [],
    // branchIds: [],
    platform: "GMEET"
}

export interface Participant {
    id: number;
    name: string;
    displayName: string;
    role: string;
    companyId: number;
    branchId: number;
}

export type AlertActionType = "WITHOUT_CONFLICT" | "ANYWAY";

export interface AlertConfig {
    type: AlertActionType;
    description: string;
    colorScheme: "green" | "red";
}

export const meetingSchema = yup.object({
    title: yup.string().trim().required("Meeting title is required").max(200),
    description: yup.string().trim().required("Description is required"),

    // companyIds: yup.array().of(yup.number()).min(1, "Select at least one company").required("Company is required"),
    // branchIds: yup.array().of(yup.number()).min(1, "Select at least one branch").required("Branch is required"),

    mode: yup.string().oneOf(["Online", "Offline"]).required("Mode is required"),


    roomNo: yup.string().when("mode", {
        is: "Offline",
        then: (schema) =>
            schema.required("Room number is required"),
        otherwise: (schema) => schema.optional(),
    }),

    startTime: yup.string().required("Start time is required"),
    endTime: yup.string().required("End time is required").test(
        "time-comparison",
        "End time must be after start time",
        function (value) {
            const { startTime } = this.parent;
            if (!startTime || !value) return true;
            return value > startTime;
        }
    ),

    date: yup.string().required("Date is required"),

    participantType: yup.string().oneOf(["Employee", "Team", "Mixed"]).required("Participant type is required"),
    platform: yup.string().when("mode", {
        is: "Online",
        then: (schema) => schema.required("Platform is required"),
    }),
});
